export default "__VITE_ASSET__4a4639f1__"